var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading && _vm.history.length
            ? _c("div", [
                _c(
                  "table",
                  { staticClass: "table mt-1 table-sm table-hover" },
                  [
                    _c(
                      "tbody",
                      _vm._l(_vm.history, function (r) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(r.file_name))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.printDate(r.created_at))),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("UploadCustomWithPreview", {
                attrs: {
                  noUseCompress: true,
                  allowToUpload: true,
                  extraData: {
                    type: 2,
                    object: "new_drug_photos",
                    objectId: _vm.objectId,
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Загрузка новых фотографий к препаратам")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }